<!--
  - Copyright (c) 2008-2019 by teambits GmbH, Darmstadt, Germany (http://www.teambits.de). All rights reserved.
  - This is CONFIDENTIAL code. Use is subject to license terms.
  -->

<script>
/**
 * Mixin providing helper methods for dealing with different kinds of links
 */
export default {
  name: "LinksMixin",

  methods: {
    httpsLink: url => "https://" + url,
    mailtoLink: email => "mailto:" + email,
    telLink: number => "tel:" + number,
  },
}
</script>
